class header {
  constructor() {
    $(document).ready(() => {
      this.headerStrip();
    });
  }

  headerStrip() {
    /**
     * handle auto-scrolling elements
     */
    var x = 0;
    var wrapper = $('.header-promotion');
    var container = wrapper.find('ul.ticker');
    var items = container.find('li');
    var containerHeight = 0;
    var numberVisible = 1;
    var intervalSec = 3000;
    var color = wrapper.data('color');

    if (typeof color !== 'undefined') {
      $('.header-banner').css('background-color', color);
    }

    if (!container.find('li:first').hasClass('first')) {
      container.find('li:first').addClass('first');
    }

    items.each(function () {
      if (x < numberVisible) {
        containerHeight += $(this).outerHeight();
        x++;
      }
    });

    container.css({
      height: containerHeight,
      overflow: 'hidden'
    });

    function verticalCycle() {
      var firstItem = container.find('li.first').html();

      container.append('<li>' + firstItem + '</li>');
      firstItem = '';
      container.find('li.first').animate({ marginTop: '-25px' }, 600, function () {
        $(this).remove();
        container.find('li:first').addClass('first');
      });
    }

    var init = setInterval(() => verticalCycle(), intervalSec);

    container.hover(function () {
      clearInterval(init);
    }, function () {
      init = setInterval(() => verticalCycle(), intervalSec);
    });

  }
}

const Header = new header();
export default Header;



// WEBPACK FOOTER //
// ./assets/scripts/components/header.js